const Privacy = () => {
  return (
    <div className="pt-24 pb-20">
      <div className="container mx-auto">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="mb-12">
            <h1 className="text-5xl md:text-6xl font-bold heading-font text-white mb-4">
              Privacy Policy
            </h1>
            <p className="text-gray-400">Last updated: January 24, 2026</p>
            <div className="mt-4 p-4 bg-white/5 rounded-lg border border-white/10">
              <p className="text-sm text-gray-400">
                This Privacy Policy is provided by <strong className="text-white">Limitly</strong>, a <strong className="text-white">Limited Liability Company</strong> registered in <strong className="text-white">New Mexico, United States</strong>.
              </p>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">1. Information We Collect</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  We collect information you provide directly to us, such as when you create an account, join our waitlist, or contact us for support.
                </p>
                <p className="text-gray-400">
                  This may include:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 text-gray-400">
                  <li>Name and email address</li>
                  <li>Company information and size</li>
                  <li>Payment and transaction information</li>
                  <li>Communications with our support team</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">2. How We Use Your Information</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  We use the information we collect to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 text-gray-400">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Process transactions and send related information</li>
                  <li>Send you technical notices and support messages</li>
                  <li>Respond to your comments and questions</li>
                  <li>Monitor and analyze trends and usage</li>
                  <li>Detect and prevent fraud and abuse</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">3. Information Sharing</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  We do not sell your personal information. We may share your information only in the following circumstances:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 text-gray-400">
                  <li>With service providers who perform services on our behalf</li>
                  <li>To comply with legal obligations</li>
                  <li>To protect the rights and safety of Limitly and our users</li>
                  <li>With your consent or at your direction</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">4. Data Security</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
                </p>
                <p className="text-gray-400">
                  However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">5. Data Retention</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  We retain your personal information for as long as necessary to provide our services and fulfill the purposes outlined in this policy, unless a longer retention period is required by law.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">6. Your Rights</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  Depending on your location, you may have certain rights regarding your personal information, including:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 text-gray-400">
                  <li>Access to your personal information</li>
                  <li>Correction of inaccurate information</li>
                  <li>Deletion of your information</li>
                  <li>Objection to processing of your information</li>
                  <li>Data portability</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">7. Cookies and Tracking</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  We use cookies and similar tracking technologies to collect information about your browsing activities and to provide you with a better experience on our website.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">8. Changes to This Policy</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">9. Contact Us</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  If you have any questions about this privacy policy, please contact us:
                </p>
                <div className="p-4 bg-white/5 rounded-lg border border-white/10">
                  <div className="space-y-2 text-gray-400">
                    <p><strong className="text-white">Limitly LLC</strong></p>
                    <p>Email: <a href="mailto:privacy@limitly.org" className="text-indigo-400 hover:text-indigo-300 transition-colors">privacy@limitly.org</a></p>
                    <p className="text-sm">
                      Address:<br />
                      LIMITLY LLC<br />
                      2105 Vista Oeste NW, Ste 3694<br />
                      Albuquerque, NM 87120<br />
                      United States
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>);

};

export default Privacy;